import React from 'react';
import clsx from 'clsx';
import styles from './AssessorCell.module.css';

export interface AssessorCellProps {
  assessorName?: string | null;
  assessorEmail?: string | null;
  className?: string;
}

const AssessorCell: React.FC<AssessorCellProps> = ({ assessorName, assessorEmail, className }) => {
  if (!assessorName) {
    return (
      <div className={clsx(styles.assessorCell, className)}>
        <span className={styles.unassigned}>Unassigned</span>
      </div>
    );
  }

  return (
    <div className={clsx(styles.assessorCell, className)}>
      <div className={styles.assessorInfoDashboard}>
        <div className={styles.assessorName}>{assessorName}</div>
        {assessorEmail && <div className={styles.assessorEmail}>{assessorEmail}</div>}
      </div>
    </div>
  );
};

export default AssessorCell;
